import React, { useState } from 'react'
import styles from './KitFieldsType.module.scss'
import { WorkflowCreationContext } from '../WorkflowCreation2';
import KitMappingFieldEditor from '../KitMappingFieldEditor/KitMappingFieldEditor';
import { convertToRaw, EditorState, RawDraftContentState } from 'draft-js';


const KitInputTypes = ({
    topActionsDetails,
    setTopActionsDetails,
    kitInputsType,
    KitInputTypesKey,
}: {
    topActionsDetails: any
    setTopActionsDetails: Function,
    kitInputsType: any
    KitInputTypesKey: any
}) => {

    const { workflowEvent, inputValuefieldKeys, setSearchOptionAreRequired } = React.useContext(WorkflowCreationContext);
    const options = (workflowEvent && workflowEvent.options) || (workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.options) || {};
    const generateRandomId = () => {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }
    const [editorContent, setEditorContent] = useState<{
        text: string;
        rawContentState: RawDraftContentState;
        internal_key: any;
        randomID: string
        mentions: any[],
    }>({
        text: '',
        rawContentState: convertToRaw(EditorState.createEmpty().getCurrentContent()),
        internal_key: '',
        randomID: generateRandomId(),
        mentions: [],
    });

    const [activeInputId, setActiveInputId] = useState(null);
    const handleFocusInput = (id: any) => {
        setActiveInputId(id);
    };

    const fieldKey = Object.keys(options).find(
        key => key === 'mapping_fields' || key === 'community_fields'
    ) || workflowEvent && (workflowEvent.slug === 'page_form/new_submission' || workflowEvent.slug === 'course-form/submitted') && 'mapping_fields'

    React.useEffect(() => {
        if (topActionsDetails && topActionsDetails.mapping_fields && topActionsDetails.mapping_fields.length > 0) {
            const data = topActionsDetails.mapping_fields.find((item: any) => (item.id === kitInputsType.id));
            setEditorContent((prev: any) => ({
                ...prev,
                ...data,
            }))
            return
        }
        if (topActionsDetails && topActionsDetails.community_fields && topActionsDetails.community_fields.length > 0) {
            const data = topActionsDetails.community_fields.find((item: any) => (item.id === kitInputsType.id));
            setEditorContent((prev: any) => ({
                ...prev,
                ...data,
            }))
            return
        }

    }, [
        topActionsDetails && topActionsDetails.mapping_fields && topActionsDetails.mapping_fields.length,
        topActionsDetails && topActionsDetails.community_fields && topActionsDetails.community_fields.length,
    ])


    React.useEffect(() => {
        const text = editorContent.text;

        setTopActionsDetails((prevState: any) => {
            const updatedState = {
                ...prevState,
                mapping_fields: [...(prevState.mapping_fields || [])],
                community_fields: [...(prevState.community_fields || [])]
            };

            if (!fieldKey) return updatedState;

            // Remove the entry if text is empty or whitespace
            if (!text || text.trim().length === 0) {
                updatedState[fieldKey] = updatedState[fieldKey].filter(
                    (item: any) => item.randomID !== editorContent.randomID
                );
                return updatedState;
            }

            // If text has value, add/update the entry
            const newEntry = {
                external_key: kitInputsType.key,
                id: kitInputsType.id,
                ...editorContent
            };

            updatedState[fieldKey] = [
                ...updatedState[fieldKey].filter(
                    (item: any) =>
                        item.randomID !== editorContent.randomID &&
                        item.id !== kitInputsType.id
                ),
                newEntry
            ];

            // Clear the opposite field
            if (fieldKey === 'community_fields') {
                updatedState.mapping_fields = [];
            } else if (fieldKey === 'mapping_fields') {
                updatedState.community_fields = [];
            }

            return updatedState;
        });
    }, [editorContent.text, kitInputsType.key, fieldKey,  kitInputsType.id]);

    // reset editor state when workflow event id changes
    React.useEffect(() => {
        if (workflowEvent && !workflowEvent.event_resource_details) {
            setEditorContent({
                text: '',
                rawContentState: convertToRaw(EditorState.createEmpty().getCurrentContent()),
                internal_key: '',
                randomID: generateRandomId(),
                mentions: [],
            });
            setTopActionsDetails((prevState: any) => {
                const updatedState = {
                    ...prevState,
                    mapping_fields: [],
                    community_fields: []
                };
                return updatedState;
            });
        }
    }, [workflowEvent && workflowEvent.event_resource_details])

    React.useEffect(() => {
        if (kitInputsType.validation && kitInputsType.validation.required) {
            setSearchOptionAreRequired((prevList: string[]) => {
                if (!prevList.includes(kitInputsType.key)) {
                    return [...prevList, kitInputsType.key];
                }
                return prevList;
            });
        }
    }, [kitInputsType.validation])

    return (
        <div className={styles.KitInputTypes}>
            {
                kitInputsType.label &&
                <h1 className={styles.KitInputTypes__sidebarTitle}>
                    {kitInputsType.label}
                    {
                        kitInputsType.validation && kitInputsType.validation.required &&
                        <small>*</small>
                    }
                </h1>
            }

            <AtMentionInput
                key={KitInputTypesKey}
                id={KitInputTypesKey}
                onFocusInput={handleFocusInput}
                isActive={activeInputId === KitInputTypesKey}
                kitInputsType={kitInputsType}
                setTopActionsDetails={setTopActionsDetails}
                fieldKey={fieldKey}
                response={inputValuefieldKeys && inputValuefieldKeys}
                editorContent={editorContent}
                setEditorContent={setEditorContent}
                topActionsDetails={topActionsDetails}
                workflowEvent={workflowEvent}
            />
        </div>
    )
}

const AtMentionInput = ({ id, onFocusInput, isActive, kitInputsType, setTopActionsDetails, fieldKey, response, editorContent, setEditorContent, topActionsDetails, workflowEvent }: any) => {
    const [searchString, setSearchString] = React.useState<string>('');
    const [isUserModalOpen, setIsWokflowMentionModalOpen] = useState(false);

    // Insert selected name at cursor position
    const handleSelectName = (data: any) => {
        setTopActionsDetails((prevState: any) => {
            const updatedState = {
                ...prevState,
                mapping_fields: [...(prevState.mapping_fields || [])],
                community_fields: [...(prevState.community_fields || [])]
            };

            const newEntry = {
                // internal_key: data.key,
                external_key: kitInputsType.key,
                id: kitInputsType.id,
                ...editorContent,
            };

            if (fieldKey) {
                updatedState[fieldKey] = [
                    ...updatedState[fieldKey].filter(
                        (item: any) =>
                            item.randomID !== data.randomID &&
                            item.id !== kitInputsType.id
                    ),
                    newEntry
                ];

                // If community_fields is being updated, clear mapping_fields
                if (fieldKey === 'community_fields') {
                    updatedState.mapping_fields = [];
                }

                // If mapping_fields is being updated, clear community_fields
                if (fieldKey === 'mapping_fields') {
                    updatedState.community_fields = [];
                }
            }

            return updatedState;
        });
    };

    const closeModal = () => {
        setIsWokflowMentionModalOpen(false);
    };

    // const filteredData = (searchString && searchString.trim() !== "")
    //     ? response.data.filter((item: any) =>
    //         item.label.toLowerCase().includes(searchString.toLowerCase())
    //     )
    //     : response.data;


    let filteredData = (searchString && searchString.trim() !== "")
        ? response.data.filter((item: any) =>
            item.label.toLowerCase().includes(searchString.toLowerCase())
        )
        : response.data;

    if (
        kitInputsType &&
        kitInputsType.validation &&
        kitInputsType.validation.type === 'email'
    ) {
        filteredData = filteredData.filter((item: any) => item.key === 'email');
    }

    return (
        <KitMappingFieldEditor
            isOpen={isActive && isUserModalOpen}
            closeModal={closeModal}
            setIsModalOpen={setIsWokflowMentionModalOpen}
            filteredData={filteredData}
            searchString={searchString}
            setSearchString={setSearchString}
            kitInputsType={kitInputsType}
            handleSelectName={handleSelectName}
            onFocusInput={() => onFocusInput(id)}
            editorContent={editorContent}
            setEditorContent={setEditorContent}
            setTopActionsDetails={setTopActionsDetails}
            topActionsDetails={topActionsDetails}
            workflowEvent={workflowEvent}
        />
    );
};


export default KitInputTypes